export function initSendMessage() {
  const messageSentForm = document.getElementById('contact-us-form')
  if (!messageSentForm) return

  const onSubmit = (e) => {
    e.preventDefault()

    fetch('/ajax/sendEmailReview', {
      method: 'post',
      headers: { 'x-requested-with': 'XMLHttpRequest' },
      body: new FormData(messageSentForm)
    })
    messageSentForm.reset()
  }

  messageSentForm.addEventListener('submit', onSubmit)
}